import React, { useRef } from "react";

import {
  Box,
  Typography,
  styled,
  TextField,
  FormHelperText,
  Button,
} from "@mui/material";
import UploadVideo from "./UploadVideo";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import UploadImg from "./uploadImg";

const CustomTextarea = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #414466",
    borderRadius: "8px",
    color: "white",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
      outline: "none",
    },

    [theme.breakpoints.down("md")]: {
      padding: "7.5px 9px",
    },

    "& .MuiInputBase-input": {
      // maxHeight: "70px",
      [theme.breakpoints.down("md")]: {
        maxHeight: "52px",

        padding: "0px",
      },
      "&.Mui-disabled": {
        WebkitTextFillColor: "inherit",
        cursor: "not-allowed !important",
      },
    },

    "&.Mui-disabled": {
      backgroundColor: "rgba(255,255,255,0.04) !important",
      border: "1px solid #2f3250 !important",
      color: "rgba(255,255,255,0.4) !important",
      cursor: "not-allowed !important",
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const Form = ({
  data,
  setGoalVideos,
  index,
  setDeletedVideos,
  goalVideos,
  addTournamentFormSubmited,
  isAdmin,
}) => {
  const mounted = useRef(false);
  const userData = useSelector((state) => state.user);
  const Admin_user_cond =
    !isAdmin &&
    goalVideos[index]?.user_id &&
    goalVideos[index].user_id !== userData.data.id;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        className="goal-seperate-form"
        sx={{ border: "1px solid #46496a", gap: "20px" }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            flexDirection: { xs: "column", md: "row", lg: "row" },
          }}
        >
          <Box className="category form-control">
            <Typography className="label">Club Name</Typography>
            <CustomTextarea
              variant="outlined"
              name="club_name"
              value={goalVideos[index].club_name}
              onChange={(e) => {
                setGoalVideos((prev) =>
                  prev.map((p, i) =>
                    i == index
                      ? { ...p, club_name: e.target.value, edited: true }
                      : { ...p },
                  ),
                );
              }}
              placeholder="Enter Club Name"
              disabled={Admin_user_cond}
            />
            {!goalVideos[index].club_name && addTournamentFormSubmited ? (
              <FormHelperText sx={{ color: "red" }}>
                Please enter the club name.
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
          <Box className="category form-control">
            <Typography className="label">Goal Scorer</Typography>
            <CustomTextarea
              variant="outlined"
              name="goal_scorer"
              value={goalVideos[index].goal_scorer}
              onChange={(e) => {
                setGoalVideos((prev) =>
                  prev.map((p, i) =>
                    i == index
                      ? { ...p, goal_scorer: e.target.value, edited: true }
                      : { ...p },
                  ),
                );
              }}
              disabled={Admin_user_cond}
              placeholder="Enter Goal Scorer"
            />
            {!goalVideos[index].goal_scorer && addTournamentFormSubmited ? (
              <FormHelperText sx={{ color: "red" }}>
                Please enter the goal scorer.
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
        </Box>

        <Box className="multi-form-tournament">
          <Box
            className="category "
            sx={{ display: "flex", alignItems: "center" }}
          >
            <UploadImg
              setGoalVideos={setGoalVideos}
              index={index}
              goalVideos={goalVideos}
              Admin_user_cond={Admin_user_cond}
            />
            {!goalVideos[index].club_img && addTournamentFormSubmited ? (
              <FormHelperText sx={{ color: "red" }}>
                Please upload the club image.
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
          <Box className="category " sx={{ flexDirection: "column" }}>
            <UploadVideo
              setGoalVideos={setGoalVideos}
              index={index}
              goalVideos={goalVideos}
              Admin_user_cond={Admin_user_cond}
            />
            {!goalVideos[index].goal && addTournamentFormSubmited ? (
              <FormHelperText sx={{ color: "red" }}>
                Please upload the goal video.
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
          {index == 0 && goalVideos.length == 1 ? null : (
            <Box sx={{ display: "flex", gap: "5px" }}>
              <Box>
                <Button
                  sx={{
                    border: "1px solid #46496a",
                    borderRadius: "8px",
                    padding: "8px 13px",
                    marginTop: "20px",

                    color: "#ef364e",

                    cursor: Admin_user_cond
                      ? "not-allowed !important"
                      : "pointer !important",

                    "&.Mui-disabled": {
                      color: "#ef364e", // override default grey
                      opacity: 0.5, // optional
                      border: "1px solid #46496a",
                      cursor: "not-allowed !important",
                    },

                    "&:hover": {
                      border: "1px solid #46496a",
                      backgroundColor: "transparent",
                    },
                  }}
                  onClick={() => {
                    if (goalVideos.length <= 1) {
                      toast.error(
                        "Please enter at least on Internation Tournament video.",
                      );
                      return;
                    }
                    goalVideos.map((goal, i) => {
                      if (i == index && goal.id) {
                        setDeletedVideos((del) => [...del, goal.id]);
                      }
                    });
                    setGoalVideos((prev) =>
                      prev.filter((state, i) => {
                        if (i == index) {
                          return false;
                        } else {
                          return true;
                        }
                      }),
                    );
                  }}
                  disabled={Admin_user_cond}
                >
                  Remove
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {data?.error && addTournamentFormSubmited && (
        <Box sx={{ width: "100%" }}>
          <FormHelperText sx={{ color: "red" }}>{data.error}</FormHelperText>
        </Box>
      )}
    </Box>
  );
};

export default Form;
